import React from 'react';
import { GLOSSARY, type GlossaryKey } from '../data/content';
const TERM_RE = /\b(token IDs?|tokens?|vectors?|embeddings?|attention|heads?|layers?|logits?|softmax|temperature)\b/gi;

/** Marks the first mention of each glossary term with a hover definition. */
export function GlossaryText({
  text
}: {
  text: string;
}) {
  const seen = new Set<GlossaryKey>();
  const parts: React.ReactNode[] = [];
  let last = 0;
  for (const match of text.matchAll(TERM_RE)) {
    const key = termKey(match[0]);
    const index = match.index ?? 0;
    if (seen.has(key)) continue;
    seen.add(key);
    parts.push(text.slice(last, index));
    parts.push(<Term key={index} term={GLOSSARY[key].term} def={GLOSSARY[key].def} data-id="element-205" data-mp="267e9sh7pzdo">
        {match[0]}
      </Term>);
    last = index + match[0].length;
  }
  parts.push(text.slice(last));
  return <>{parts}</>;
}
function Term({
  term,
  def,
  children
}: {
  term: string;
  def: string;
  children: React.ReactNode;
}) {
  return <span className="group relative cursor-help underline decoration-white/30 decoration-dotted underline-offset-[3px]" data-id="element-206" data-mp="2i19c0rp8rt1t">
      {children}
      <span role="tooltip" className="pointer-events-none absolute bottom-full left-0 z-30 mb-1.5 w-60 rounded-lg border border-white/10 bg-[#12141D] p-2.5 text-[12px] leading-[18px] text-[#C9CCD8] opacity-0 shadow-xl transition-opacity duration-150 group-hover:opacity-100" data-id="element-207" data-mp="eg37nd711n38">
        <span className="mb-0.5 block font-medium text-[#EDEEF2]" data-id="element-208" data-mp="3mveftx1f8tw0">{term}</span>
        {def}
      </span>
    </span>;
}
function termKey(match: string): GlossaryKey {
  const m = match.toLowerCase();
  if (m.startsWith('token id')) return 'tokenId';
  if (m.startsWith('token')) return 'token';
  if (m.startsWith('vector') || m.startsWith('embedding')) return 'vector';
  if (m.startsWith('head')) return 'head';
  if (m.startsWith('layer')) return 'layer';
  if (m.startsWith('logit')) return 'logit';
  if (m === 'softmax') return 'softmax';
  if (m === 'temperature') return 'temperature';
  return 'attention';
}